<template>
  <!-- 投資型基本輸入：版型八　定期+彈性繳VA -->
  <div>
    <div class="row mt_16">
      <div class="col create_title">規劃保費</div>
    </div>
    <!-- 保費 -->
    <div class="form-group d-flex align-items-end mt_20">
      <div class="d-flex text-norwap mr_8">
        <strong style="line-height: 40px">規劃保費:</strong>
      </div>
      <div class="d-flex align-items-center mr_8">
        <!-- 繳別 -->
        <label>繳別:</label>
        <select
          class="form-control"
          style="width: 8rem"
          :id="'pay_freq'"
          data-vv-name="pay_freq"
          :class="{ 'is-invalid': errors.has('pay_freq') }"
          v-validate="`required`"
          data-vv-as="繳別"
          v-model="productDataScope.pay_freq"
          @change="
            productDataScope.first_premium &&
              $validator.validate(`first_premium`);
          "
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(payFreqOption, index) in option.payFreq_option"
            :key="index.paraval"
            :value="payFreqOption.paraval"
          >
            {{ payFreqOption.paradetlno }}
          </option>
        </select>
      </div>
      <!-- 定期保費 -->
      <div class="d-flex align-items-center mr_8">
        <strong style="line-height: 40px" class="mr_4">定期保費:</strong>
        <div class="position-relative">
          <div
            class="notice-top text-red"
            v-if="PRODUCT_FEATURE_DATA.face_prem_incr_unit != '0'"
          >
            {{
              `需以${formatMethods(
                PRODUCT_FEATURE_DATA.face_prem_incr_unit
              )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
            }}
          </div>
          <div class="d-flex align-items-center">
            <!-- |pol_premium -->
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('pol_premium') }"
              :id="'pol_premium'"
              :data-vv-name="'pol_premium'"
              :disabled="productDataScope.pay_freq=='6'"
              v-validate.continues="{
                required: true,
                pol_premium: productDataScope.pol_premium,
              }"
              data-vv-as="定期保費"
              @input="
                numberHandler(productDataScope, 'pol_premium', $event);
                resetPaymethod();
              "
              @blur="numberHandler(productDataScope, 'pol_premium', $event);productDataScope.first_premium &&
              $validator.validate(`first_premium`);$validator.validate(`pol_premium`);"
              :value="productDataScope.pol_premium | formatMethods"
              :placeholder="
                productDataScope.pay_freq &&
                prem_limit[productDataScope.pay_freq]
                  ? `${formatMethods(
                      converIncrUnit(
                        prem_limit[productDataScope.pay_freq].prem_floor
                      )
                    )}~${
                      prem_limit[productDataScope.pay_freq].prem_ceil < 0
                        ? '無上限'
                        : formatMethods(
                            converIncrUnit(
                              prem_limit[productDataScope.pay_freq].prem_ceil
                            )
                          )
                    }`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>

      <!-- 不定期保費 -->
      <div class="d-flex align-items-center">
        <strong style="line-height: 20px; white-space:pre; text-align:center;" class="mr_4">{{`不定期保費:\n(第一次繳費)`}}</strong>
        <div class="position-relative">
          <div
            class="notice-top text-red"
            v-if="PRODUCT_FEATURE_DATA.face_prem_incr_unit != '0'"
          >
            {{
              `需以${formatMethods(
                PRODUCT_FEATURE_DATA.face_prem_incr_unit
              )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
            }}
          </div>
          <div class="d-flex align-items-center">
            <!-- |first_premium -->
            <input
              type="tel"
              class="form-control mr_2"
              style="width: 175px"
              :class="{ 'is-invalid': errors.has('first_premium') }"
              :id="'first_premium'"
              :data-vv-name="'first_premium'"
              v-validate.continues="{
                required: true,
                first_premium: productDataScope.first_premium,
              }"
              data-
              data-vv-as="不定期保費"
              @input="
                numberHandler(productDataScope, 'first_premium', $event);
              "
              @blur="numberHandler(productDataScope, 'first_premium', $event)"
              :value="productDataScope.first_premium | formatMethods"
              :placeholder="
                productDataScope.pay_freq &&
                first_prem_limit[productDataScope.pay_freq]
                  ? `${formatMethods(
                      converIncrUnit(
                        first_prem_limit[productDataScope.pay_freq]
                          .prem_floor
                      )
                    )}~${
                      first_prem_limit_ceil < 0
                        ? '無上限'
                        : formatMethods(
                            converIncrUnit(
                              first_prem_limit_ceil
                            )
                          )
                    }`
                  : ''
              "
            />
          </div>
        </div>
        <span>{{ currTranser(PRODUCT_FEATURE_DATA.curr, true) }}</span>
      </div>
    </div>
    
    <!-- 新增不定期保費 -->
    <div class="form-group d-flex align-items-center mt_20">
      <!-- 新增繳費方式 -->
      <div class="position-relative d-inline-block">
        <div class="notice-top" style="bottom: 52px">非必要欄位，可不輸入</div>
        <a
          class="btn btn-default"
          style="line-height: 20px; height: 44px"
          @click="addPayMethods()"
        >
          新增繳費方式
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
import moment from "moment";
export default {
  props: ["productDataScope", "mainIndex", "option"],
  mixins: [mf_Mixin],
  data() {
    return {
      first_prem_limit: [{}, {}, {}, {}],
      prem_limit: [{}, {}, {}, {}],
      getINVPremiumLimitTimer: null,
      getINVAmountTimer: null,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
    first_prem_limit_ceil() {
      //取得第一次不定期保費上限
      let prem_ceil = parseInt(
        this.first_prem_limit[this.productDataScope.pay_freq].prem_ceil
      );
      if (this.productDataScope.pay_freq != "6") {
        //繳別不等於彈性繳，則MAX(mfm00200.high_prem_limit減掉[定期保險費],0)
        prem_ceil =
          prem_ceil - parseInt(this.productDataScope.pol_premium || 0);
      }
      return prem_ceil < 0 ? 0 : prem_ceil;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.productDataScope.pol_premium_tmp = this.productDataScope.pol_premium;
      this.productDataScope.dueage_tmp = this.productDataScope.dueage;

      this.getINVLimitRanges();
    },
    async addPayMethods() {
      const checkResult = await this.$validator.validateAll();
      let has_dueage = new Boolean(this.productDataScope.dueage).valueOf();
      if (!checkResult || !has_dueage) {
        if (!has_dueage) {
          this.$bus.emit("event_dueage", this.productDataScope.dueage);
        }
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      } else {
        this.productDataScope.dueage_tmp = this.productDataScope.dueage;
        this.productDataScope.pol_premium_tmp = this.productDataScope.pol_premium;
        this.$router.push("/mf/create/addPayment3");
      }
    },
    async getINVLimitRanges() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let {
        first_prem_limit,
        prem_limit,
      } = await this.$mfAPI.MFB1_0100__getINVLimitRanges({
        prod_id: this.nowProduct.prod_id,
        insured_actage: insured_actage,
        insured_age: this.MfEditing.insured.insured_age,
        insured_gender: this.MfEditing.insured.insured_gender,
      });
      this.first_prem_limit = first_prem_limit;
      this.prem_limit = prem_limit;
      this.initValidator();
    },
    initValidator() {
      Validator.extend(`first_premium`, {
        getMessage: "",
        validate: (value) => {
          if (!this.productDataScope.pay_freq) return false;
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          let ceil =
            this.first_prem_limit_ceil < 0
              ? Infinity
              : this.first_prem_limit_ceil;
          return (
            (!this.productDataScope.pay_freq ||
              (intValue <= ceil &&
                intValue >=
                  this.first_prem_limit[this.productDataScope.pay_freq]
                    .prem_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
      Validator.extend(`pol_premium`, {
        getMessage: "",
        validate: (value) => {
          if (!this.productDataScope.pay_freq) return false;
          let intValue = parseInt(value.split(",").join(""));
          //符合保費遞增與保額上下限
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          let ceil =
            this.prem_limit[this.productDataScope.pay_freq].prem_ceil < 0
              ? Infinity
              : this.prem_limit[this.productDataScope.pay_freq].prem_ceil;
          return (
            (!this.productDataScope.pay_freq ||
              (intValue <= ceil &&
                intValue >=
                  this.prem_limit[this.productDataScope.pay_freq]
                    .prem_floor)) &&
            intValue % incr_unit === 0
          );
        },
      });
    },
    converIncrUnit(number) {
      let face_prem_incr_unit =
        this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
          ? 1
          : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
      return Math.floor(number / face_prem_incr_unit) * face_prem_incr_unit;
    },
    async validateAll() {
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
    resetPaymethod() {
      if (this.productDataScope.paymethod) {
        this.$mfNotice(
          "修改定期保險費,若有輸入的不定期保費將全部清除,是否仍要修改?",
          () => {
            this.productDataScope.paymethod = null;
            this.productDataScope.temp__paymethod = null; //要對應"新增繳費"VUE的參數，才會清除成功
          },
          true,
          () => {
            this.productDataScope.dueage = this.productDataScope.dueage_tmp;
            this.productDataScope.pol_premium = this.productDataScope.pol_premium_tmp;
            this.$validator.reset();
          },
          "確定清除"
        );
      }
    },
  },
  watch: {
    "productDataScope.pay_freq": {
      handler() {
        if (this.productDataScope.pay_freq != 6) {
          this.productDataScope.pol_premium =
            this.productDataScope.pol_premium || "";
        } else {
          this.productDataScope.pol_premium = 0;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin-right: 8px !important;
  line-height: 40px;
  white-space: nowrap;
}
</style>
